export default __webpack_public_path__ + "static/media/l-4.d50fd85d.jpg";